import { FC } from 'react';

import { Schemas } from '@api-client/generated/types';
import { getMissingInvoicingFields, type MissingInvoicingField } from '@utils';

import * as S from './styled';

type BillingRequirementsAlertProps = {
  company?: Schemas.AdminCompanyResponseDto | null;
  /** Precomputed missing fields; falls back to deriving them from `company`. */
  missingFields?: MissingInvoicingField[];
  /** Overrides the default heading above the missing-fields list. */
  message?: string;
  className?: string;
};

const DEFAULT_MESSAGE =
  'Billing cannot be enabled until the following invoicing details are filled in on the Company Info tab:';

/**
 * Warns that the company is missing data required to issue invoices, and lists
 * the specific fields. Renders nothing once all required fields are present.
 */
const BillingRequirementsAlert: FC<BillingRequirementsAlertProps> = ({
  company,
  missingFields,
  message = DEFAULT_MESSAGE,
  className,
}) => {
  const fields = missingFields ?? getMissingInvoicingFields(company);

  if (!fields.length) {
    return null;
  }

  return (
    <S.Banner
      className={className}
      type="warning"
      showIcon
      message={message}
      description={
        <S.List>
          {fields.map((field) => (
            <li key={field.key}>{field.label}</li>
          ))}
        </S.List>
      }
    />
  );
};

export default BillingRequirementsAlert;
